// extracted by mini-css-extract-plugin
export default {"Accordion":"Accordion_Accordion__7Qf-1","Title_Active":"Accordion_Title_Active__J5q6s","Title_Inactive":"Accordion_Title_Inactive__0fhMR","Content":"Accordion_Content__bsJMH"};